import React from "react";
import "./Skills.css";
import SkillSection from "./SkillSection";
import { Fade } from "react-reveal";
import Divider from "../../components/divider/divider";
import { useTranslation } from "react-i18next";

export default function Skills(props) {
  const { t } = useTranslation();
  const theme = props.theme;
  return (
    <div className="main" id="skills">
      <div className="skills-header-div">
        <Fade bottom duration={2000} distance="20px">
          <h1 className="skills-header" style={{ color: theme.text }}>
            {t("skills.header")}
          </h1>
          <div className="div-container">
            <Divider />
          </div>
        </Fade>
      </div>
      <SkillSection theme={theme} />
    </div>
  );
}
